module.exports = __webpack_public_path__ + "img/btn_bg.027375eb.png";